/*
 * Copyright (C) 2025 Hendrik. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 * Written by Hendrik, December 28, 2025.
 */

import React, { useState, useEffect } from 'react';
import './Login.css'; // Reuse login styles for consistency
import PushNotificationSettings from './components/PushNotificationSettings.jsx';

export default function Settings() {
    const [gradeDisplayFormat, setGradeDisplayFormat] = useState('levels');
    const canManageFoundation = localStorage.getItem('is_admin') === 'true' || localStorage.getItem('user_role') === 'developer';

    useEffect(() => {
        // Load saved preference
        const saved = localStorage.getItem('gradeDisplayFormat');
        if (saved) {
            setGradeDisplayFormat(saved);
        }
    }, []);

    const handleFormatChange = (format) => {
        setGradeDisplayFormat(format);
        localStorage.setItem('gradeDisplayFormat', format);
    };

    const getGradeExample = (percentage) => {
        if (percentage >= 80) return gradeDisplayFormat === 'levels' ? '7' : 'A*';
        if (percentage >= 70) return gradeDisplayFormat === 'levels' ? '6' : 'A';
        if (percentage >= 60) return gradeDisplayFormat === 'levels' ? '5' : 'B';
        if (percentage >= 50) return gradeDisplayFormat === 'levels' ? '4' : 'C';
        if (percentage >= 40) return gradeDisplayFormat === 'levels' ? '3' : 'D';
        if (percentage >= 30) return gradeDisplayFormat === 'levels' ? '2' : 'E';
        return gradeDisplayFormat === 'levels' ? '1' : 'F';
    };

    return (
        <div className="login-wrapper">
            <div className="login-card" style={{ maxWidth: '600px' }}>
                <div className="brand-section">
                    <h1>Settings</h1>
                    <p>Customize your Marksure experience</p>
                </div>

                <div className="settings-content" style={{ textAlign: 'left', lineHeight: '1.6' }}>
                    <div className="setting-group" style={{ marginBottom: '30px', padding: '20px', border: '1px solid #eee', borderRadius: '8px' }}>
                        <h3 style={{ marginBottom: '15px', color: '#333' }}>Grade Display Format</h3>
                        <p style={{ marginBottom: '15px', color: '#666', fontSize: '0.9em' }}>
                            Choose how final grades are displayed in your mark sheets and reports.
                        </p>

                        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name="gradeFormat"
                                    value="levels"
                                    checked={gradeDisplayFormat === 'levels'}
                                    onChange={(e) => handleFormatChange(e.target.value)}
                                    style={{ marginRight: '8px' }}
                                />
                                <span style={{ fontWeight: gradeDisplayFormat === 'levels' ? 'bold' : 'normal' }}>
                                    CAPS Levels (1-7)
                                </span>
                            </label>

                            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name="gradeFormat"
                                    value="symbols"
                                    checked={gradeDisplayFormat === 'symbols'}
                                    onChange={(e) => handleFormatChange(e.target.value)}
                                    style={{ marginRight: '8px' }}
                                />
                                <span style={{ fontWeight: gradeDisplayFormat === 'symbols' ? 'bold' : 'normal' }}>
                                    International Symbols (A*-F)
                                </span>
                            </label>
                        </div>

                        <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '6px', border: '1px solid #e9ecef' }}>
                            <h4 style={{ marginBottom: '10px', fontSize: '0.9em', color: '#495057' }}>Preview:</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))', gap: '10px' }}>
                                {[95, 85, 75, 65, 55, 45, 35].map(percentage => (
                                    <div key={percentage} style={{ textAlign: 'center', padding: '8px', background: 'white', borderRadius: '4px', border: '1px solid #dee2e6' }}>
                                        <div style={{ fontSize: '0.8em', color: '#6c757d' }}>{percentage}%</div>
                                        <div style={{ fontSize: '1.2em', fontWeight: 'bold', color: '#495057' }}>
                                            {getGradeExample(percentage)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {canManageFoundation && (
                        <div className="setting-group" style={{ marginBottom: '30px', padding: '20px', border: '1px solid #dce7dd', borderRadius: '8px', background: '#f8fcf8' }}>
                            <h3 style={{ marginBottom: '15px', color: '#24462d' }}>Foundation Phase Configuration</h3>
                            <p style={{ marginBottom: '15px', color: '#5c6d5f', fontSize: '0.9em' }}>
                                Open the admin editor for Foundation Phase CAPS weights, task max marks, report mark conversions, and Grade R task labels.
                            </p>

                            <a
                                href="/foundation-phase"
                                style={{
                                    display: 'inline-block',
                                    padding: '10px 16px',
                                    background: '#24462d',
                                    color: '#fff',
                                    textDecoration: 'none',
                                    borderRadius: '6px',
                                    fontWeight: 'bold'
                                }}
                            >
                                Manage Foundation Phase
                            </a>
                        </div>
                    )}

                    <PushNotificationSettings />

                    <div style={{ textAlign: 'center', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
                        <p style={{ margin: 0, color: '#666', fontSize: '0.9em' }}>
                            Settings are saved automatically and apply to all your subjects and reports.
                        </p>
                    </div>
                </div>

                <div className="login-footer">
                    <p><a href="/dashboard" className="privacy-link">← Back to Dashboard</a></p>
                </div>
            </div>
        </div>
    );
}
